import * as React from 'react';
import { darken } from 'polished';
import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';

const BaseWrapper = css`
  position: relative;
  background-color: ${({ theme }) => darken(0.05, theme.colors.redwine)};
  text-decoration: none;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const CardWrapper = styled.div`
  ${BaseWrapper}
`;

export const CardLinkWrapper = styled((props) => <Link {...props} />)`
  ${BaseWrapper}
`;

export const CardLink = styled((props) => <Link {...props} />)`
  text-decoration: none;
`;
